import { AppBar, Container, Toolbar, Button } from '@mui/material'
import { ErrorOutline as ErrorOutlineIcon, QueueOutlined as QueueOutlinedIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'

const DeadLetterNav = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const isQueuesActive = location.pathname.startsWith('/dead-letter/queues')
  const isDeadLettersActive = !isQueuesActive

  return (
    <AppBar position="sticky" elevation={0} sx={(theme) => ({ backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary, top: 0, mb: 0, borderBottom: `1px solid ${theme.palette.divider}` })}>
      <Container maxWidth="xl" disableGutters>
        <Toolbar disableGutters variant="dense">
          <Button
            color="inherit"
            startIcon={<ErrorOutlineIcon />}
            onClick={() => navigate('/dead-letter')}
            sx={{ ml: 2, fontWeight: isDeadLettersActive ? 'bold' : 'normal', borderBottom: isDeadLettersActive ? '2px solid' : 'none', borderRadius: 0 }}
          >
            {t('menu.deadLetters')}
          </Button>
          <Button
            color="inherit"
            startIcon={<QueueOutlinedIcon />}
            onClick={() => navigate('/dead-letter/queues')}
            sx={{ ml: 1, fontWeight: isQueuesActive ? 'bold' : 'normal', borderBottom: isQueuesActive ? '2px solid' : 'none', borderRadius: 0 }}
          >
            {t('menu.queues')}
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default DeadLetterNav
